// extracted by mini-css-extract-plugin
module.exports = {"arrow":"arrow-module--arrow--pRDTc"};